
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_b07k1_153",
  "button": "awsui_button_vjswe_b07k1_157",
  "variant-normal": "awsui_variant-normal_vjswe_b07k1_206",
  "disabled": "awsui_disabled_vjswe_b07k1_224",
  "variant-primary": "awsui_variant-primary_vjswe_b07k1_231",
  "variant-link": "awsui_variant-link_vjswe_b07k1_256",
  "variant-icon": "awsui_variant-icon_vjswe_b07k1_281",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_b07k1_306",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_b07k1_331",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_b07k1_356",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_b07k1_385",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_b07k1_410",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_b07k1_435",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_b07k1_465",
  "button-no-text": "awsui_button-no-text_vjswe_b07k1_557",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_b07k1_561",
  "full-width": "awsui_full-width_vjswe_b07k1_564",
  "icon-left": "awsui_icon-left_vjswe_b07k1_586",
  "icon-right": "awsui_icon-right_vjswe_b07k1_591",
  "icon": "awsui_icon_vjswe_b07k1_586",
  "link": "awsui_link_vjswe_b07k1_610",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_b07k1_610"
};
  